// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__8UgAM","loader":"Loader_loader__fKF97"};